import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { Suspense, useState } from "react";
import { ThemeProvider } from "@blueskydataplatform/shared-ui/theme/theme-provider";
import { ConfirmationServiceProvider } from "@blueskydataplatform/shared-ui/components/ui/confirmation/confirmation-service-provider";
import { Toaster } from "@blueskydataplatform/shared-ui/components/ui/sonner";
import { Spinner } from "@blueskydataplatform/shared-ui/components/ui/spinner";
import { queryConfig } from "./lib/react-query";
import { EnterpriseContactServiceProvider } from "@blueskydataplatform/shared-ui/modules/enterprise/enterpise-contact-provider";
import { ConsentBanner } from "@blueskydataplatform/shared-ui/components/consent-banner";
import { useUtmCapture } from "@blueskydataplatform/shared-ui/hooks/use-utm-capture";
import { McpProvidersProvider } from "./providers/mcp-providers-context";

type AppProviderProps = {
  children: ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  useUtmCapture();
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: queryConfig,
      })
  );

  return (
    <Suspense
      fallback={
        <div className="flex h-screen w-screen items-center justify-center">
          <Spinner size="large" />
        </div>
      }
    >
      <QueryClientProvider client={queryClient}>
        <ThemeProvider defaultTheme="system" storageKey="ui-theme">
          <Toaster />
          <EnterpriseContactServiceProvider>
            <McpProvidersProvider>
              <ConfirmationServiceProvider>{children}</ConfirmationServiceProvider>
            </McpProvidersProvider>
          </EnterpriseContactServiceProvider>
          <ConsentBanner />
        </ThemeProvider>
      </QueryClientProvider>
    </Suspense>
  );
};
